/**
 * React hook that fires a page_view event on every route change.
 *
 * Drop this into any component rendered inside a <Router>:
 *
 *   import { usePageTracking } from '../analytics/usePageTracking';
 *   function AppContent() {
 *     usePageTracking();
 *     ...
 *   }
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './index';

export function usePageTracking(): void {
  const location = useLocation();
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    // Avoid duplicate fires for the same path (e.g. StrictMode double-render)
    if (previousPath.current === location.pathname) return;
    previousPath.current = location.pathname;

    trackPageView(location.pathname);
  }, [location.pathname]);
}
